<template>
    <div class="parkings-search">
        <div class="parkings-search-top">
            <van-search v-model="keyword" show-action placeholder="搜索" @search="onSearch">
                <template #action>
                    <van-button class="searchBtn" @click="onSearch">搜索</van-button>
                </template>
            </van-search>
            <van-tabs sticky @change="handleTabChange" color="#009AF3" line-width="30%" line-height="2px" title-active-color="#009AF3" title-inactive-color="#333333">
                <van-tab :title="item.name" :name="item.id" v-for="(item, index) in tabList" :key="index"></van-tab>
            </van-tabs>
        </div>
        <div class="overflow">
            <parking-list :parkingLotList="parkingLotList" />
        </div>
        <van-empty description="附近暂无停车场" v-if="parkingLotList.length == 0" />
    </div>
</template>

<script>
import { getParkDistribute } from "@/api/api";
import ParkingList from "@/components/parking/parking-list.vue";

export default {
    name: "ParkingsSearch",
    components: {
        ParkingList,
    },
    data() {
        return {
            keyword: "", //关键字
            tabList: [
                {
                    name: "全部",
                    id: "0",
                },
                {
                    name: "道路",
                    id: "1",
                },
                {
                    name: "停车场",
                    id: "2",
                },
            ],
            parkingLotList: [], //车场
            parkingList: [], //用于保存所有车场
        };
    },
    mounted() {
        this.getParkingList();
    },

    methods: {
        //获取停车场
        getParkingList() {
            getParkDistribute(this.$route.params).then((res) => {
                if (res.code == 200) {
                    this.parkingLotList = res.data.rows;
                    this.parkingList = res.data.rows;
                }
            });
        },
        //搜索
        onSearch() {
            this.handleTabChange(0);
        },
        //切换停车场类型，根据搜索出的停车场在前端过滤
        handleTabChange(value) {
            this.parkingLotList = this.parkingList.filter((item) => {
                if (this.keyword) {
                    let pattern = new RegExp(`${this.keyword}`, "g");
                    if (value == "1") return item.type == "1" && pattern.test(item.parkName);
                    else if (value == "2") return item.type == "2" && pattern.test(item.parkName);
                    else return item && pattern.test(item.parkName);
                }
                if (value == "1") return item.type == "1";
                else if (value == "2") return item.type == "2";
                else return item;
            });
        },
    },
};
</script>

<style lang="less" scoped>
.parkings-search-top {
    height: 205px;
}

.parkings-search {
    .searchBtn {
        width: 112px;
        height: 66px;
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        border-radius: 16px;
        font-size: 28px;
        white-space: nowrap;
        color: #ffffff;
    }
}
</style>
